import _ from 'lodash';

const formatURL = function(urlStr, params) {
  return urlStr + '?' + 
    new URLSearchParams(_.pickBy(params, _.negate(_.isNil))).toString();
}

export default formatURL
